import {SlideRuleBaseModel} from "./slide-rule-base.model";
import {GameInfo} from "../../../games/game-info";
import {ISlideRenderer} from "../../video-slides.service.interface";
import {VideoStreamGameSlideRenderer} from "../../video-slides-renderers/video-stream-game-slide.renderer";

export class VideoStreamSlideRuleModel extends SlideRuleBaseModel {
    protected createVideoSlideRenderer(gameInfo: GameInfo): ISlideRenderer {
        return new VideoStreamGameSlideRenderer(gameInfo, this.services);
    }
}